<script>
  import DetailView from "./DetailView.svelte";
  import { Button } from "../../../Components";
  import { Loading } from "../../../Components/Icons";
  import OnetooneStatus from "./OnetooneStatus.svelte";
  import { doLoading } from "../../Api/congress_stores.js";

  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  let showLoading = false;

  doLoading.subscribe((value) => {
    showLoading = value;
  });

  export let item;
  // export let anmeldestop = false;
  export let anmeldestopO2o = false;
  export let eventlistData = {};

  function processBookingAction(actionType) {
    doLoading.update(() => true);

    // Check if the user is registered for the congress
    if (actionType.startsWith("booking") && item.tnHasKongress != 1) {
      alert("Sie sind nicht für diesen Kongress angemeldet.");
      doLoading.update(() => false);
      return;
    }

    dispatch("booking", { actionType, actionId: item.veranstaltungId });
  }
</script>

<DetailView {item} headline="One to One">
  <svelte:fragment slot="whitebox">
    {#if eventlistData.tnHasSeat == 1}
      <p class="text-green-700">Sie sind für dieses One to One Gespräch angemeldet.</p>
      {#if !anmeldestopO2o}
        <Button
          minor
          on:click={() => {
            processBookingAction("unbooking");
          }}
          >Abmelden
          <Loading {showLoading} />
        </Button>
      {/if}
    {:else if showLoading}
      <Loading />
    {/if}
  </svelte:fragment>
  <svelte:fragment slot="box">
    <div class="my-2 flex justify-end">
      <a href="/kongress/mein-account#myEvents|overview" class="text-theme-signal"
        ><svg class="svg-inline--fa fa-xl" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
          ><path
            d="M64 64C46.3 64 32 78.3 32 96v64H480V96c0-17.7-14.3-32-32-32H64zM32 192V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V192H32zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 256H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16zM352.2 90.3L384 109.3l31.8-19.1c7.6-4.5 17.4-2.1 21.9 5.5s2.1 17.4-5.5 22l-40 24c-5.1 3-11.4 3-16.5 0l-40-24c-7.6-4.5-10-14.4-5.5-22s14.4-10 21.9-5.5z"
          ></path></svg
        ></a
      >
    </div>
    {#if eventlistData.tnHasSeat != 1 && !showLoading}
      <div class="-mx-3 overflow-x-auto px-3">
        {#if eventlistData.o2otimetable}
          <table class="w-full table-auto border-collapse text-xs [&_td]:border-black [&_td]:text-center [&_td]:align-middle [&_th]:border-current [&_th]:font-normal">
            <thead class="text-xs">
              <tr>
                <th class="border-b-2 border-r-2" />
                {#each [...Array(10).keys()] as index}
                  <th class="border-b-2 p-1 leading-none">{`0${index + 8}`.slice(-2)}:00<br /> – <br />{`0${index + 9}`.slice(-2)}:00</th>
                {/each}
              </tr>
            </thead>
            <tbody>
              <tr>
                <th class="border-r-2 pr-1">{eventlistData.o2otimetable.day1Name}</th>
                {#each eventlistData.o2otimetable.day1Statuslist as timeslot}
                  <OnetooneStatus {timeslot} anmeldestop={anmeldestopO2o} veranstaltungId={eventlistData.veranstaltungId} tnHasKongress={eventlistData.tnHasKongress} on:booking />
                {/each}
              </tr>
              <tr>
                <th class="border-r-2 pr-1">{eventlistData.o2otimetable.day2Name}</th>
                {#each eventlistData.o2otimetable.day2Statuslist as timeslot}
                  <OnetooneStatus {timeslot} anmeldestop={anmeldestopO2o} veranstaltungId={eventlistData.veranstaltungId} tnHasKongress={eventlistData.tnHasKongress} on:booking />
                {/each}
              </tr>
            </tbody>
          </table>
        {:else}
          <Loading display="block" class="mx-auto my-8" />
        {/if}
      </div>
    {/if}
  </svelte:fragment>
</DetailView>
